import { request2 } from "./request.js";

// 类别划分被关联数据接口
// 获取学员类被关联
export function GetCateBaseCList() {
  return request2({
    url: "/api2/TZsbAdminStudentApi/CategoryBase/GetCateBaseCList",
    method: "get",
  });
}
// 获取学员列表
export function GetCategorytList(obj) {
  return request2({
    url: "/api2/TZsbAdminStudentApi/Category/GetCategorytList",
    method: "get",
    params: obj,
  });
}
// 通过id 获取指定类型划分下的所有类别数据
export function GetCatetListByType(id) {
  return request2({
    url: "/api2/TZsbAdminStudentApi/Category/GetCatetListByType",
    method: "get",
    params: {
      id,
    },
  });
}

// 添加学员类别
export function Create(obj) {
  return request2({
    url: "/api2/TZsbAdminStudentApi/Category/Create",
    method: "post",
    data: obj,
  });
}
// 编辑学员类别
export function Update(obj) {
  return request2({
    url: "/api2/TZsbAdminStudentApi/Category/Update",
    method: "post",
    data: obj,
  });
}
// 删除学员类别
export function Delete(id) {
  return request2({
    url: "/api2/TZsbAdminStudentApi/Category/Delete",
    method: "post",
    params: {
      id,
    },
  });
}
